document.addEventListener('DOMContentLoaded', function () {
    const questionnaireWrappers = document.querySelectorAll('.questionnaire-wrapper');
    questionnaireWrappers.forEach(wrapper => {
        const form = wrapper.querySelector('form');
        // const formCheckElements = form.querySelectorAll('div.form-check');
        // formCheckElements.forEach(element => {
        //     element.addEventListener('click', (ev) => {
        //         // If the click is directly on the input or label, don't handle it
        //         if (ev.target.tagName.toLowerCase() === 'input' ||
        //             ev.target.tagName.toLowerCase() === 'label') {
        //             return;
        //         }
        //
        //         const input = element.querySelector('input');
        //         if (input) {
        //             input.checked = !input.checked;
        //             // Dispatch a change event to trigger any other listeners
        //             input.dispatchEvent(new Event('change'));
        //         }
        //     });
        // });
        
        const formElements = form.querySelectorAll('textarea, input, select');
            formElements.forEach(formElement => {
                ['change', 'input', 'keyup'].forEach(eventType => {
                formElement.addEventListener(eventType, () => {
                    validateQuestionnaireForm(formElement.closest('form'));


                    if (formElement.type === 'textarea' || formElement.type === 'text')
                    {
                        const formGroup = formElement.closest('div.form-group');

                        const validationAttr = formGroup.getAttribute('data-validation');
                        try {
                            const parsedData = JSON.parse(validationAttr);
                            if (typeof parsedData.maxChars !== 'undefined')
                            {
                                const charCountOut = formGroup.querySelector('.js-char-count-out');
                                const charCountTemplate = charCountOut.getAttribute('data-text-template');
                                const currentCharsStringHtml = formElement.value.length > parsedData.maxChars.value ? '<span class="text-danger">' + formElement.value.length + '</span>' : formElement.value.length;
                                charCountOut.innerHTML = charCountTemplate
                                    .replace('%currentChars%', currentCharsStringHtml)
                                    .replace('%maxChars%', parsedData.maxChars.value)
                                    .replace(/\s+/g, ' ')
                                    .trim();
                            }
                        } catch (e){
                            console.warn('Invalid JSON in data-validation attribute:', validationAttr);
                        }

                    }


                });
                formElement.dispatchEvent(new Event('change'));
            });
        });

        form.addEventListener('submit', event => {

            form.classList.add('validation-enabled');

            if (!validateQuestionnaireForm(form)) {
                event.preventDefault();
                event.stopPropagation();

                const firstInvalidElement = form.querySelector('.form-group .is-invalid');
                if (firstInvalidElement) {
                    const formGroup = firstInvalidElement.closest('.form-group');
                    formGroup.scrollIntoView({behavior: 'smooth', block: 'start'});
                }


            }

        }, false)

    });


});

function validateQuestionnaireForm(form) {
    var formValid = true;
    const formElements = form.querySelectorAll('textarea, input, select');
    formElements.forEach(formElement => {

        formElement.classList.remove('is-invalid');

            if (!form.classList.contains('validation-enabled')) {
                return formValid;
            }

            const validationData = {};
        const formGroup = formElement.closest('div.form-group');

            if(formGroup) {

                formGroup.classList.remove('is-invalid');

                let formCheck = formGroup.querySelectorAll('div.form-check');
                let formAnswerList = formGroup.querySelectorAll('div.answer-options-list');

                if(formAnswerList.length > 0) {
                    formAnswerList.forEach(element => {
                        element.classList.remove('is-invalid');
                    });
                }

                const messageOut = formGroup.querySelector('.invalid-feedback');
                messageOut.innerHTML = '';

                if (formGroup && formGroup.hasAttribute('data-validation')) {
                    const validationAttr = formGroup.getAttribute('data-validation');
                    try {
                        const parsedData = JSON.parse(validationAttr);
                        if (parsedData) {

                            switch (formGroup.getAttribute('data-type')) {
                                case('text'):

                                    if (typeof parsedData.regexCheck !== 'undefined') {

                                        let regex = new RegExp(parsedData.regexCheck.regex, parsedData.regexCheck.regexFlags);

                                        if(!regex.test(formElement.value))
                                        {
                                            formElement.classList.add('is-invalid');
                                            messageOut.innerHTML = '<div class="error-message" data-type="minChars">' + parsedData.regexCheck.message + '</div>';
                                            formValid = false;
                                        }
                                    }

                                    if (typeof parsedData.minChars !== 'undefined' && parsedData.minChars.value > 0 && formElement.value.length < parsedData.minChars.value) {
                                        formElement.classList.add('is-invalid');
                                        messageOut.innerHTML = '<div class="error-message" data-type="minChars">' + parsedData.minChars.message + '</div>';
                                        formValid = false;
                                    }

                                    if (typeof parsedData.maxChars !== 'undefined' && parsedData.maxChars.value > 0 && formElement.value.length > parsedData.maxChars.value) {

                                        formElement.classList.add('is-invalid');
                                        messageOut.innerHTML = '<div class="error-message" data-type="minChars">' + parsedData.maxChars.message + '</div>';
                                        formValid = false;
                                    }



                                    break;

                                case('checkbox'):

                                    const checkedCount = formGroup.querySelectorAll('input[type="checkbox"]:checked').length;

                                    formCheck.forEach(formCheckElement => {
                                        formCheckElement.classList.remove('is-invalid');
                                    });
                                    
                                    if (typeof parsedData.minChoices !== 'undefined' && parsedData.minChoices.value > 0 && checkedCount < parsedData.minChoices.value) {
                                        formElement.classList.add('is-invalid');
                                        formAnswerList.forEach(formAnswerElement => {
                                            formAnswerElement.classList.add('is-invalid');
                                        });                                        formCheck.forEach(formCheckElement => {
                                            formCheckElement.classList.add('is-invalid');
                                        });                                        formGroup.classList.add('is-invalid');
                                        messageOut.innerHTML = messageOut.innerHTML + '<div class="error-message" data-type="minChars">' + parsedData.minChoices.message + '</div>';
                                        formValid = false;
                                    }

                                    if (typeof parsedData.maxChoices !== 'undefined' && parsedData.maxChoices.value > 0 && checkedCount > parsedData.maxChoices.value) {
                                        formElement.classList.add('is-invalid');
                                        formAnswerList.forEach(formAnswerElement => {
                                            formAnswerElement.classList.add('is-invalid');
                                        });
                                        formCheck.forEach(formCheckElement => {
                                            formCheckElement.classList.add('is-invalid');
                                        });
                                        formGroup.classList.add('is-invalid');
                                        messageOut.innerHTML = messageOut.innerHTML + '<div class="error-message" data-type="minChars">' + parsedData.maxChoices.message + '</div>';
                                        formValid = false;
                                    }
                                    
                                    break;

                                case('radio'):

                                    formCheck.forEach(formCheckElement => {
                                        formCheckElement.classList.remove('is-invalid');
                                    });

                                    if (typeof parsedData.notEmpty.message !== 'undefined' && formGroup.querySelector('input[type="radio"]:checked') === null) {
                                        formElement.classList.add('is-invalid');
                                        formAnswerList.forEach(formAnswerElement => {
                                            formAnswerElement.classList.add('is-invalid');
                                        });
                                        formCheck.forEach(formCheckElement => {
                                            formCheckElement.classList.add('is-invalid');
                                        });
                                        formGroup.classList.add('is-invalid');
                                        messageOut.innerHTML = messageOut.innerHTML + '<div class="error-message" data-type="minChars">' + parsedData.notEmpty.message + '</div>';
                                        formValid = false;
                                    }
                                    
                                    break;

                                default:
                                    console.log('Unknown field data type', formGroup.getAttribute('data-type'));

                                    break;
                            }

                        }
                    } catch (e) {
                        if (validationAttr !== false) {
                            console.warn('Invalid JSON in data-validation attribute:', validationAttr);
                        }
                        else
                        {
                            console.warn('Other validation error: ', e.message, ' for ', validationAttr);
                        }
                    }
                }
            }
    });
    return formValid;
}